import React, { Component } from 'react';

import numeral from 'numeral';

import { getDateDisplay, walletIdsToHideLatipayLogo } from '../../utils';

import logo from '../../assets/logo.svg';

import img from '../../assets/bg_top_right.svg';
import btmLeftImg from '../../assets/bg_btm_left.svg';
import failedImg from '../../assets/tran_failed.svg';

import './index.css';

const titles = {
  wechat: 'WeChat Pay',
  alipay: 'Alipay',
  latipay: 'MoneyMore',
  polipay: 'NZ bank account',
  unionpay: 'UnionPay',
  coin_payments: 'Crypto'
};

export default class Page extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);

    const payment_method = params.get('payment_method') || '';
    const order_id = params.get('order_id');
    const status = params.get('status');
    const in_money_more = params.get('in_money_more');
    const discountsString = params.get('discounts');
    let discounts = [];
    if (discountsString) {
      console.log(discountsString);

      try {
        discounts = JSON.parse(decodeURIComponent(discountsString));
      } catch (e) {
        console.log(e);
      } finally {
      }
    }

    if (
      payment_method.toLowerCase() === 'polipay' &&
      in_money_more === 'true'
    ) {
      window.location.href = `latipaycustomer://polipay?id=${order_id}&status=${status}`;
    }

    this.state = { payment_method, order_id, status, discounts };

    if (status === 'paid') {
      sessionStorage.removeItem('amount');
    }
  }

  render() {
    const params = new URLSearchParams(this.props.location.search);
    const status = params.get('status');

    const payment_method = params.get('payment_method');
    const merchant_reference = params.get('merchant_reference');

    const amount = params.get('amount');
    const currency = params.get('currency') || 'NZD';

    const createDate = params.get('createDate');
    const order_id = params.get('order_id');
    const accountName = params.get('accountName') || params.get('account_name'); //account_name from polipay;

    const error_code = params.get('error_code');
    const retry_url = params.get('retry_url');
    const walletId = params.get('wallet_id');

    const hideLogo = walletIdsToHideLatipayLogo.includes(walletId);

    const discounts = this.state.discounts;

    let dateString;
    if (createDate) {
      const date = new Date(createDate.replace(' ', 'T') + 'Z');
      dateString = getDateDisplay(date);
    }

    const isPaid =
      order_id !== undefined && order_id !== '' && status === 'paid';

    const isStaging =
      window.location.hostname === 'localhost' ||
      window.location.hostname.indexOf('-staging') !== -1;

    return (
      <div className="pg pg-staticqr-result">
        <div className="card">
          <div className="container">
            <div className="info">
              <img
                style={{ zIndex: 1, opacity: hideLogo ? 0 : 1 }}
                src={logo}
                alt="latipay"
              />
              <img className="img-top-right" src={img} alt="" />

              <div className="preview">
                <div className="centered" style={{ paddingTop: '20px' }}>
                  {isPaid && (
                    <svg
                      width="86px"
                      height="86px"
                      viewBox="0 0 86 86"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <rect
                          id="path-1"
                          x="0"
                          y="0"
                          width="351"
                          height="708"
                          rx="15"
                        />
                      </defs>
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="支付方式2备份"
                          transform="translate(-145.000000, -182.000000)"
                        >
                          <g
                            id="编组-14"
                            transform="translate(12.000000, 90.000000)"
                          >
                            <mask id="mask-2" fill="white">
                              <use xlinkHref="#path-1" />
                            </mask>
                            <use id="蒙版" fill="#FFFFFF" xlinkHref="#path-1" />
                            <g id="Icon" mask="url(#mask-2)" stroke="#68C371">
                              <g transform="translate(133.000000, 92.000000)">
                                <circle
                                  id="Oval"
                                  strokeOpacity="0.43588833"
                                  strokeWidth="1"
                                  fillOpacity="0.739182692"
                                  fill="#68C371"
                                  fillRule="evenodd"
                                  opacity="0.149999991"
                                  cx="43"
                                  cy="43"
                                  r="42.5"
                                />
                                <polyline
                                  id="Path"
                                  strokeWidth="4"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  points="24 44.497346 35.9843103 56.4816563 62.4659667 30"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  )}

                  {!isPaid && <img src={failedImg} alt="" />}

                  <div className="result">
                    {isPaid ? 'Payment successful' : 'Payment Unsuccessful'}
                  </div>
                  {error_code === '309' && (
                    <div className="message">
                      Merchant has not yet verified & activated their account.
                      Please contact merchant.
                    </div>
                  )}

                  <div className="amount-container">
                    <div className="payment-amount">Payment Amount</div>
                    {amount && (
                      <div className="amount">
                        {payment_method === 'Crypto' &&
                          numeral(amount).format('0,0.00000')}
                        {payment_method !== 'Crypto' &&
                          numeral(amount).format('0,0.00')}
                        <span>{currency}</span>
                      </div>
                    )}
                  </div>
                </div>

                {!isPaid &&
                  retry_url && (
                    <a className="btn-try-again" href={retry_url}>
                      Try again
                    </a>
                  )}

                <div>
                  {accountName && (
                    <div className="flexed">
                      <div className="preview-title">Payee</div>
                      <div className="preview-value">{accountName}</div>
                    </div>
                  )}
                </div>

                {isPaid && (
                  <div>
                    {payment_method && (
                      <div className="flexed">
                        <div className="preview-title">Payment method</div>
                        <div className="preview-value">
                          {titles[payment_method.toLowerCase()] ||
                            payment_method}
                        </div>
                      </div>
                    )}

                    {order_id && (
                      <div className="flexed">
                        <div className="preview-title">Transaction ID</div>
                        <div className="preview-value">{order_id}</div>
                      </div>
                    )}

                    {dateString && (
                      <div className="flexed">
                        <div className="preview-title">Date</div>
                        <div className="preview-value">{dateString}</div>
                      </div>
                    )}

                    {merchant_reference && (
                      <div className="flexed">
                        <div className="preview-title">Reference</div>
                        <div className="preview-value">
                          {merchant_reference}
                        </div>
                      </div>
                    )}

                    {discounts &&
                      discounts.length > 0 &&
                      discounts.map((item, index) => (
                        <div key={index} className="flexed">
                          <div className="preview-title">
                            {item.discountNote}
                          </div>
                          <div className="preview-value">
                            {item.discountAmt}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {isPaid &&
                order_id && (
                  <div className="show-to-merchant">
                    <span>You may need to show merchant this page</span>
                  </div>
                )}
            </div>

            <img className="img-btm-left" src={btmLeftImg} alt="" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/StaticQR2Result/index.js